import { useEffect, useRef, useState } from "react";

import HorizontalRule from "../../../../../components/Rule/Horizontal";
import { GoToTop } from "../../../../Talk";
import { RentalStockTab } from "../../../../../components/RentalStock/RentalStockTab";
import RentalStockChange from "./Change";
import useStoreHeader from "../../../../../hooks/useStoreHeader";
import RentalStockHistory from "./History";

type Props = {};

export default function RentalStockControl(props: Props) {
  const scrollDivRef = useRef<HTMLDivElement>(null);
  const [activeServiceTab, setActiveServiceTab] = useState<string>("change");

  const onClickRefresh = () => {
    if (activeServiceTab === "change") RentalStockChangeReload();
    else RentalStockHistoryReload();
  };

  const [{ storeId }, storeHeader] = useStoreHeader({
    onClickRefresh,
  });

  const [{ RentalStockChangeReload }, RentalStockChangeComponent] =
    RentalStockChange({
      active: activeServiceTab === "change",
      storeId: storeId ?? "",
    });

  const [{ RentalStockHistoryReload }, RentalStockHistoryComponent] =
    RentalStockHistory({
      active: activeServiceTab === "history",
      storeId: storeId ?? "",
    });

  useEffect(() => {
    scrollDivRef.current?.scrollIntoView();
    //onClickRefresh();
  }, [activeServiceTab, storeId]);

  return (
    <div ref={scrollDivRef}>
      {storeHeader}
      <div className="px-5">
        <div className="flex justify-between items-center pt-[30px]">
          <div className="flex items-center">
            <RentalStockTab
              active={activeServiceTab === "change"}
              onClick={() => setActiveServiceTab("change")}
            >
              재고 변경
            </RentalStockTab>
            <RentalStockTab
              active={activeServiceTab === "history"}
              onClick={() => setActiveServiceTab("history")}
            >
              변경 이력
            </RentalStockTab>
          </div>
        </div>
      </div>
      <HorizontalRule margin="0" />
      {activeServiceTab === "change"
        ? RentalStockChangeComponent
        : RentalStockHistoryComponent}
      <div className="fixed bottom-5 right-5 flex flex-col gap-2.5 z-[19]">
        <div
          className="border border-brand-floating-secondary-button rounded-[10px] p-2 bg-white cursor-pointer"
          onClick={() => {
            scrollDivRef.current?.scrollIntoView({ behavior: "smooth" });
          }}
          style={{ boxShadow: "2px 5px 4px 0px rgba(0, 0, 0, 0.10)" }}
        >
          <GoToTop />
        </div>
      </div>
    </div>
  );
}
